import { getStore } from 'src/utils/firebase/firebase-short-cut';
import useSWRImmutable from 'swr/immutable';

const useSWRStore = (storeId: string | null) => {
  const {
    data: store,
    isLoading,
    error,
    mutate,
  } = useSWRImmutable(storeId ? `store-${storeId}` : null, () => getStore(storeId as string));

  return {
    store,
    isLoading,
    error,
    refresh: () => mutate(),
  };
};

export default useSWRStore;
